
<div class="container">
  <div class="row">
    <error [error]="error" style="width: 100%;"></error>
  </div>
  <div class="row" *ngIf="message &amp;&amp; !message.details">
    <div class="alert alert-info"><span>STATUS - {{message | json}}</span></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row justify-content-md-center" *ngIf="highRadiusErrorMessage.message">
        <div class="alert alert-danger col-md-10"><span>{{ highRadiusErrorMessage.message }}<span *ngIf="highRadiusErrorMessage.support">You may log a ticket at<a class="ml-1 error-link" href="javascript:void(0);" (click)="showSupportModal()">&nbsp;HP NOW.</a></span></span>
          <ul *ngIf="highRadiusErrorMessage.list">
            <li *ngFor="let item of highRadiusErrorMessage.list;"><span>{{item}}</span></li>
          </ul>
          <p *ngIf="highRadiusErrorMessage.showEmailNotificationSent">An email has been sent to all relevant people associated with this Project regarding this credit check failure.<br>Additionally the Credit and Collections for the Project&apos;s Region have also been notified.</p>
        </div>
      </div>
      <div class="row justify-content-md-center mb-1" *ngIf="enableHighRadiusFlag">
        <div class="col-md-10 p-0">
          <div *ngIf="firstTimeCreditCheck"><span>No credit check has been done for this project. On submit of Master Agreement Request will perform credit check.</span></div>
          <div *ngIf="lastCreditCheckSuccess"><span class="oi oi-check pr-1" style="color:green;"></span>Credit Check Passed on {{lastCreditCheckDate | date: 'yyyy-MM-dd'}}.<a class="ml-2" href="javascript:void(0);" (click)="showCreditCheckLogModal()">Credit Check Log.</a></div>
          <div *ngIf="lastCreditCheckFail &amp;&amp; !firstTimeCreditCheck"><span class="oi oi-warning pr-1" style="color:red;"></span>Last Credit Check did not pass. Release it before continuing to MA creation.<a class="ml-2" href="javascript:void(0);" (click)="showCreditCheckLogModal()">Credit Check Log.</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="isNovationProcess">
    <div class="alert alert-warning col-md-11"><span></span><b>Warning: </b><span>Novation is currently in progress. Master agreement changes are not allowed at this time. Please contact support if the issue persists.     </span></div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Master Agreement Name</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.masterAgreementDescription}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Start Date</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.maStartDate}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Master Agreement External ID</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.externalId}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Master Agreement Internal #</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.currentMaInternalId}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>ITSM Customer Name</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.itsmCustomerName}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>ITSM Customer ID</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.itsmCustomerId}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Opportunity ID</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.opportunityId}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Customer PO Number</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.custPoItemNo}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Submitted By</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.submittedBy}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Submission Time</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.submittedTs}}&nbsp;</div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Transaction ID</div>
                <div class="border-bottom text-secondary">{{masterAgreementStatus?.pendingMaTransactionId}}&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="showPoRequest">
    <div class="col" *appSetting="'enableDIS'">
      <div class="card-item p-4">
        <div class="row mb-2">
          <div class="col-12">
            <h5 class="float-left mb-3">Provider Order for DIS</h5>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="deviceISFiltered.length" (onChange)="onListControlsChange($event)"></list-controls>
              </div>
            </div>
            <table class="table table-responsive customer-table">
              <thead>
                <tr class="table-header-with-controls">
                  <th style="width: 12%;">Selection</th>
                  <th class="wp-15">Product ID</th>
                  <th class="wp-15">Customer ID</th>
                  <th>Item Description</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="deviceIS">
                  <ng-container *ngFor="let device of deviceISToShow; let idx = index;">
                    <tr>
                      <td class="form-group">
                        <div class="form-check">
                          <input type="checkbox" name="selectedDeviceISCheckBox" [(ngModel)]="device.selected" (click)="selectCheckBox(device)" [disabled]="device.currentPoStatus === 3 || device.currentPoStatus === 1">
                        </div>
                      </td>
                      <td [ngClass]="{'text-muted font-italic': device.currentPoStatus === 3 || device.currentPoStatus === 1}">{{device.productNumber}}</td>
                      <td [ngClass]="{'text-muted font-italic': device.currentPoStatus === 3 || device.currentPoStatus === 1}">{{device.customId}}</td>
                      <td [ngClass]="{'text-muted font-italic': device.currentPoStatus === 3 || device.currentPoStatus === 1}">{{device.itemDesc}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <div class="col-12 text-center">
              <button class="btn" [ngClass]="enableCreatePO ? 'btn-outline-primary' : 'btn-outline-secondary'" [disabled]="!enableCreatePO" (click)="sendDevIndServ()">Create Provider Orders</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="masterAgreementStatus &amp;&amp; masterAgreementStatus.lastMasterAgreementReturnStatus &amp;&amp; masterAgreementStatus.lastMasterAgreementReturnStatus.returnResults &amp;&amp; masterAgreementStatus.lastMasterAgreementReturnStatus.returnResults.errorMessage">
    <div class="col">
      <div class="card-item">
        <div class="row mb-2">
          <div class="col-lg-6">
            <div class="mt-2">
              <h5 class="float-left">Last Returned MA Status<i *ngIf="masterAgreementStatus &amp;&amp; masterAgreementStatus.lastMasterAgreementReturnStatus &amp;&amp; masterAgreementStatus.lastMasterAgreementReturnStatus.receivedDate"> ( {{ masterAgreementStatus.lastMasterAgreementReturnStatus.receivedDate }} )</i></h5>
            </div>
          </div>
          <div class="col-lg-6 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide Split Data" *ngIf="toggleLastStatusControls" (click)="toggleLastStatusControls = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show Split Data" *ngIf="!toggleLastStatusControls" (click)="toggleLastStatusControls = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
        </div>
        <ng-container *ngIf="toggleLastStatusControls">
          <div class="row justify-content-md-center">
            <h4>{{masterAgreementStatus.lastMasterAgreementReturnStatus.returnResults.errorMessage}}</h4>
          </div>
          <div class="row"> 
            <ul *ngIf="errorDetails?.length">
              <li>{{masterAgreementStatus.lastMasterAgreementReturnStatus.returnResults.errors[0].kind}}<i> -</i> {{masterAgreementStatus.lastMasterAgreementReturnStatus.returnResults.errors[0].message}}<br><b>Error Details -</b></li>
              <ul *ngFor="let errors of errorDetails">
                <ul *ngFor="let line of errors"> <i>{{line}}</i></ul>
              </ul>
            </ul>
          </div>
          <ng-container *ngIf="masterAgreementStatus.solutions &amp;&amp; masterAgreementStatus.solutions.length">
            <div class="row justify-content-md-center">
              <h4>Status for each solution</h4>
            </div>
            <div class="row">
              <ul>
                <li *ngFor="let solution of masterAgreementStatus.solutions"><b>{{solution.masterKey}} - {{solution.type}}</b> - {{solution.itemDesc}}<i> ( {{solution.customText}} )</i><br>{{solution.state}}</li>
              </ul>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row" *privilege="'manage-service-accounts'">
    <div class="col" *appSetting="'simplifyDebugMode'">
      <div class="card-item">
        <div class="row mb-2">
          <div class="col-lg-6">
            <div class="mt-2">
              <h5 class="float-left font-italic">Debug Controls (only open for simplify UAT)</h5>
            </div>
          </div>
          <div class="col-lg-6 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide Split Data" *ngIf="toggleDebugControls" (click)="toggleDebugControls = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show Split Data" *ngIf="!toggleDebugControls" (click)="toggleDebugControls = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
        </div>
        <ng-container *ngIf="toggleDebugControls">
          <div class="row justify-content-md-center" *ngIf="masterAgreementStatus.pendingMaTransactionId">
            <div class="col"><b>Last used filename: {{masterAgreementStatus.pendingMaTransactionId}}</b></div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col" *appSetting="'simplifyDebugMode'"><a class="btn btn-outline-secondary ml-1 btn-block" [downloadFile]="'/api/projects/export-master-agreement-debug-report'" [params]="{projectId: projectId}"><span class="oi oi-cloud-download"></span> Download Master Agreement Debug Report'</a></div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col" *appSetting="'simplifyDebugMode'"><a class="btn btn-outline-secondary ml-1 btn-block" [downloadFile]="'/api/projects/export-master-agreement-raw'" [params]="{projectId: projectId}"><span class="oi oi-cloud-download"></span> Download raw Master Agreement json data</a></div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col" *appSetting="'simplifyDebugMode'">
              <input class="form-control" type="text" [(ngModel)]="debugManualInternalId" maxlength="20">
            </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="debugManuallyAddProject()"><span class="oi oi-cloud-upload"></span> Manually add Master Agreement for testing purposes</button>
            </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="abandonTransaction()"><span class="oi oi-cloud-upload"></span> Abandon Master Agreement for testing purposes</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="manuallyOnboard()"><span class="oi oi-cloud-upload"></span> Manually Send Onboard request</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="emulateOnboard()"><span class="oi oi-cloud-upload"></span> Emulate Successful Onboarding request</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="sendDevIndServPoRequests()"><span class="oi oi-cloud-upload"></span> Create Device Independent Service orders</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="clearDevIndServPoStatus()"><span class="oi oi-cloud-upload"></span> Clear Device Independent Service order results</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col"> </div>
            <div class="col" *appSetting="'simplifyDebugMode'">
              <button class="btn btn-outline-secondary" type="button" (click)="timeoutPendingPoRequests()"><span class="oi oi-cloud-upload"></span> Timeout pending Device Independent Service order requests</button>
            </div>
            <div class="col"> </div>
          </div>
          <div class="row">
            <div class="col"> </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="validationErrors?.length">
    <div class="col">
      <div class="card-item">
        <div class="alert alert-danger">
          <div class="row mb-2">
            <div class="col-lg-10">
              <div class="mt-2">
                <H3>Validation errors exist. Please fix before proceeding.</H3>
              </div>
            </div>
            <div class="col-lg-2 text-right"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide Split Data" *ngIf="toggleValidationErrorDisplay" (click)="toggleValidationErrorDisplay = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show Split Data" *ngIf="!toggleValidationErrorDisplay" (click)="toggleValidationErrorDisplay = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
          </div>
          <ng-container *ngIf="toggleValidationErrorDisplay">
            <div class="row mb-2">
              <div class="col-lg-12">
                <div class="mt-2">
                  <div class="row">
                    <ul *ngIf="validationErrors?.length">
                      <li *ngFor="let error of validationErrors">{{error}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="container mb-3" *ngIf="showCreate &amp;&amp; workflowTargetInfo.correctRole">
    <div class="row justify-content-md-center mb-">
      <H4>Create a new Master Agreement and export it to gERP</H4>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button class="btn btn-primary" id="exportMasterAgreementButton" type="button" (click)="exportMasterAgreement()" [disabled]="exportDisabled"><span class="oi oi-cloud-upload"></span> Export Master Agreement</button>
      </div>
    </div>
  </div>
  <div class="container mb-3" *ngIf="showAppend">
    <div class="row justify-content-md-center">
      <H4>Append a new solution to the Current Master Agreement</H4>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button class="btn btn-primary" id="appendMasterAgreementButton" type="button" (click)="appendMasterAgreement()" [disabled]="exportDisabled"><span class="oi oi-cloud-upload"></span> Append the Master Agreement</button>
      </div>
    </div>
  </div>
  <div class="container mb-3" *ngIf="showOnboard">
    <div class="row justify-content-md-center">
      <H4>Manually resend ITSM Onboarding request for project</H4>
    </div>
    <div class="row text-center">
      <div class="col-12 text-center">
        <button class="btn btn-primary" id="resendOnboardingButton" type="button" (click)="manuallyOnboard()" [disabled]="exportDisabled">Reattempt ITSM project onboard</button>
      </div>
    </div>
  </div>
  <div class="container mb-3" *ngIf="showUpdatePending">
    <div class="row justify-content-md-center">
      <H3>A request to ITSM or gERP is currently being processed. Please come back later</H3>
    </div>
  </div>
  <div class="container" *ngIf="nothingToDo">
    <div class="row justify-content-md-center">
      <H3>No further action required at this time</H3>
    </div>
  </div>
</div>